import React from 'react';

const RightArrowSimple1 = (props) => {
  const { svgClass, pathClass, width, height } = props;
  
  return (
    <svg id="Layer_2" className={svgClass} width={width} height={height} viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
      <g id="Frame">
        <path id="Vector" className={pathClass} d="M6.6875 3.62183L12.3125 9.24683L6.6875 14.8718" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  );
}

export default RightArrowSimple1;
